import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsnav-bar',
	templateUrl:'./BSNavBarPluginCompPage.html',
	styles: [],
	styleUrls:['./BSNavBarPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSNavBarPluginCompPage
{
	mdContent_840 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.navbar.BSNavBar;
\`\`\``;
	mdContent_841 = `\`\`\`java
BSNavBar()
\`\`\``;
	mdContent_842 = `\`\`\`java
BSNavBar(String collapsedFieldName)
\`\`\``;
	mdContent_843 = `\`\`\`java
BSNavBar&lt;?&gt; nav = new BSNavBar&lt;&gt;();
nav.addBrand("My App", "/logo.png");
nav.addHeaderText("Dashboard");
nav.setNavBarTheme(BSNavBarColourSchemes.Navbar_Dark);
nav.addBackground(BSBackgroundOptions.Bg_Primary);
nav.setCollapseWhen(BSSizes.Lg);
\`\`\``;
}
